module.exports = "https://coursera_assets.s3.amazonaws.com/images/1591c77f431657630d1b980b203bf06b.png";